/**
 * Plans and Services view related Actions
 */
export const PLANS_AND_SERVICES_FILTER_UPDATED = 'PLANS_AND_SERVICES_FILTER_UPDATED';
export function ebPlansAndServicesFilterUpdated(selectedValues, name) {
  return {
    type: PLANS_AND_SERVICES_FILTER_UPDATED,
    selectedValues,
    name,
  };
}

export const PLANS_AND_SERVICES_BENEFITS_FILTER_RESET = 'PLANS_AND_SERVICES_BENEFITS_FILTER_RESET';
export function ebPlansAndServicesBenefitsFilterReset() {
  return {
    type: PLANS_AND_SERVICES_BENEFITS_FILTER_RESET,
  };
}

export const PLANS_AND_SERVICES_TOGGLE_FILTER = 'PLANS_AND_SERVICES_TOGGLE_FILTER';
export function ebPlansAndServicesToggleFilter(event, expanded, filterName) {
  return {
    type: PLANS_AND_SERVICES_TOGGLE_FILTER,
    filterName,
    expanded,
  };
}

export const PLANS_AND_SERVICES_BENEFITS_SERVICES_FILTER_RESET =
  'PLANS_AND_SERVICES_BENEFITS_SERVICES_FILTER_RESET';
export function ebPlansAndServicesBenefitsServicesFilterReset() {
  return {
    type: PLANS_AND_SERVICES_BENEFITS_SERVICES_FILTER_RESET,
  };
}

export const PLANS_AND_SERVICES_RETIREMENT_PLANS_FILTER_RESET =
  'PLANS_AND_SERVICES_RETIREMENT_PLANS_FILTER_RESET';
export function ebPlansAndServicesRetirementPlansFilterReset() {
  return {
    type: PLANS_AND_SERVICES_RETIREMENT_PLANS_FILTER_RESET,
  };
}

export const PLANS_AND_SERVICES_RETIREMENT_SERVICES_FILTER_RESET =
  'PLANS_AND_SERVICES_RETIREMENT_SERVICES_FILTER_RESET';
export function ebPlansAndServicesRetirementServicesFilterReset() {
  return {
    type: PLANS_AND_SERVICES_RETIREMENT_SERVICES_FILTER_RESET,
  };
}

export const PLANS_AND_SERVICES_FILTER_RESET = 'PLANS_AND_SERVICES_FILTER_RESET';
export function ebPlansAndServicesFilterReset() {
  return {
    type: PLANS_AND_SERVICES_FILTER_RESET,
  };
}
